import { render, staticRenderFns } from "./NotificationsDialog.vue?vue&type=template&id=916737f6"
import script from "./NotificationsDialog.vue?vue&type=script&lang=js"
export * from "./NotificationsDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDialog.vue?vue&type=style&index=0&id=916737f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports